<rask-fieldset-toggle
    label="Väglager"
    [formGroup]="form"
    [defaultExpanded]="open"
    [nrOfSelectedFilters]="filterLength">
    <rask-checkbox-list
        label="Väglager"
        [formControlName]="name"
        [items]="options"
        [selected]="form.value.vaglager">
    </rask-checkbox-list>
</rask-fieldset-toggle>